export default "__VITE_ASSET__BjoCncgY__"